export const ANALYTICS_EVENTS = {
    USER_REGISTRATION: 'USER_REGISTRATION',
    USER_LOGIN: 'USER_LOGIN',
    RESET_PASSWORD: 'RESET_PASSWORD',
    CREATE_ADOBE_IO_INTEGRATION: 'CREATE_ADOBE_IO_INTEGRATION',
    CREATE_EXPERIENCE: 'CREATE_EXPERIENCE',
    BULK_UPLOAD_EXPERIENCE: 'BULK_UPLOAD_EXPERIENCE',
    ACTIVATE_EXPERIENCE: 'ACTIVATE_EXPERIENCE',
    UPDATE_EXPERIENCE: 'UPDATE_EXPERIENCE',
    DELETE_EXPERIENCE: 'DELETE_EXPERIENCE',
    CREATE_TEMPLATE: 'CREATE_TEMPLATE',
    UPDATE_TEMPLATE: 'UPDATE_TEMPLATE',
    DELETE_TEMPLATE: 'DELETE_TEMPLATE',
    UPGRADE_SUBSCRIPTION_PLAN: 'UPGRADE_SUBSCRIPTION_PLAN',
    EXECUTE_FUNCTION: 'EXECUTE_FUNCTION',
    INVITE_NEW_USER: 'INVITE_NEW_USER',
    BLOCK_EXISTING_USER: 'BLOCK_EXISTING_USER',
    UNBLOCK_EXISTING_USER: 'UNBLOCK_EXISTING_USER',
    GENERATE_AI_VARIANTS: 'GENERATE_AI_VARIANTS',
    GENERATE_EXISTING_TEMPLATE_VARIANTS: 'GENERATE_EXISTING_TEMPLATE_VARIANTS',
};
